import { render } from "./AgentKickedView.vue?vue&type=template&id=12fd7cb6&scoped=true"
import script from "./AgentKickedView.vue?vue&type=script&lang=js"
export * from "./AgentKickedView.vue?vue&type=script&lang=js"

import "./AgentKickedView.vue?vue&type=style&index=0&id=12fd7cb6&scoped=true&lang=css"
import "./AgentKickedView.vue?vue&type=style&index=1&id=12fd7cb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fd7cb6"]])

export default __exports__